import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'tk',
    fullName: 'Turkmen',
    nativeName: 'Türkmen dili',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Geň galdyryjy bir zat gelýär",
    landing_subtitle: "ArgVoid programma we oýun ösüş studiýasydyr. Üns beriň, ýakyn wagtda täze zatlar geler!",
    select_language: "Dil saýlaň",
    search_placeholder: "Dil gözläň ...",
    terms_title: "Hyzmat şertleri",
    policy_title: "Gizlinlik syýasaty",
    cookies_title: "Gutapjyk syýasaty",
    terms_content: `
        <strong>1. Şertleriň kabul edilmegi</strong><br>
        ArgVoid-e girmek bilen bu Hyzmat şertleri kabul edilýär. Bu şertler razy bolmasa, hyzmaty ulanmaly däl.<br><br>

        <strong>2. Platformanyň ulanylyşy</strong><br>
        ArgVoid we amaly programmalar maglumat we döredijilik maksatlary üçin "bolşy ýaly" üpjün edilýär. Hyzmat diňe kanuny maksatlar üçin ulanylmaly.<br><br>

        <strong>3. Gadagan edilen özüňi alyp barmak</strong><br>
        Sahypanyň gowşak ýerlerinden peýdalanmak, spam ýazmak ýa-da infrastruktura birugsat girmäge synanyşmak düýbünden gadagan. <br><br>

        <strong>4. Düşündiriş</strong><br>
        Platforma we hyzmatlar islendik wagt duýdurmazdan üýtgedilip bilner. Hyzmatyň dowamlylygy ýa-da elýeterliligi barada hiç hili kepillik berilmeýär.
    `,
    policy_content: `
        <strong>1. Maglumat ýygyndysy</strong><br>
        Platforma häzirki wagtda ulanyjynyň hakykylygyny ýa-da hasaby döretmegi talap etmeýär. Şahsy kesgitleýji maglumat (atlar ýa-da e-poçta salgylary ýaly) myhmanlardan işjeň ýygnalmaýar.<br><br>

        <strong>2. Data</strong><br> ulanmak
        Esasy, anonim analitikler sahypanyň traffigine düşünmek we programmalary gowulandyrmak üçin ýygnalyp bilner. Bu maglumatlar aýratyn ulanyjy şahsyýetleri bilen baglanyşykly däl.<br><br>

        <strong>3. Üçünji tarap hyzmatlary</strong><br>
        Üçünji tarap üpjün edijiler hosting we seljeriş hyzmatlary üçin ulanylyp bilner. Bu degişli üpjün edijileriň gizlinlik amallary, infrastrukturasynda işlenýän näbelli maglumatlary dolandyrýar.<br><br>

        <strong>4. Maglumat howpsuzlygy</strong><br>
        Platformany goramak üçin ygtybarly howpsuzlyk çäreleri durmuşa geçirilýär. Şeýle-de bolsa, internet arkaly ýaýratmagyň hiç hili usuly düýbünden howpsuz däl. <br><br>
    `,
    cookies_content: `
        <strong>1. Kukiler we ýerli ammar näme? </strong><br>
        Kukiler we brauzer ýerli ammary, saparlaryň dowamynda konfigurasiýa ileri tutmalaryny ýatda saklamak üçin enjamda saklanýan kiçijik maglumat faýllarydyr. <br><br>

        <strong>2. Ulanyş maksady</strong><br>
        Brauzer LocalStorage: <br> ýaly konfigurasiýa sazlamalaryny saklamak üçin berk ulanylýar
        - Dil saýlawlary<br>
        - Ulanyjy interfeýs konfigurasiýasy (meselem, ýerleşiş ýa-da tema sazlamalary) <br>
        - Wagtlaýyn programma keşi<br><br>

        <strong>3. Gözegçilik ýok</strong><br>
        Kukiler we ýerli ammar mahabat ýa-da üçünji tarap yzarlamak maksady bilen ulanylmaýar. Saklanan maglumatlaryň hemmesi platformanyň esasy işleýşine degişlidir. <br><br>

        <strong>4. Dolandyryş</strong><br>
        Brauzer maglumatlary islendik wagt ýerli konfigurasiýalary täzeden düzjek brauzer sazlamalary arkaly arassalanyp bilner.
    `,
    cookie_consent_text: "Sahypaňyzy işjeň saklamak, dil islegiňizi tygşytlamak we beýleki adaty konfigurasiýalar ýaly web sahypasynyň dogry işlemegini üpjün etmek üçin esasy gutapjyklary ulanýarys.",
    read_policy: "Gutapjyk syýasatyny okaň",
    support_title: "Goldaw goldawy",
    support_subject_label: "Mowzuk",
    support_message_label: "Habar",
    support_submit_button: "Habar iber",
    support_hint: "Bellik: Habar ibermek üçin adaty e-poçta programmaňyzy açar.",
    support_success_msg: "E-poçta programmaňyzy açmak ...",
    support_error_msg: "Habar iberilmedi Soňrak synanyşyň.",
    explorer_title: "Gözlegçi",
    history_title: "Taryh",
    animation_title: "Animasiýa",
    config_title: "Sazlama",
    tool_mouse: "(Ctrl + M) saýlaň",
    tool_brush: "Çotga (Ctrl + B)",
    tool_brush_mode: "Reodeimini üýtgediň (Gaty / Arassa)",
    tool_eraser: "Öçüriji (Ctrl + E)",
    tool_brush_size: "Çotganyň ululygyny sazlaň",
    tool_bucket: "Doldur (Ctrl + F)",
    tool_eyedropper: "Göz gamaşdyryjy",
    tool_grid: "Grid (Ctrl + Shift + B)",
    tool_rotate: "Aýlanmak (Ctrl + Shift + R)",
    tool_flip_h: "Flip H (Ctrl + Shift + H)",
    tool_flip_v: "Flip V (Ctrl + Shift + V)",
    tool_transpose: "Geçiriň (Ctrl + Shift + T)",
    label_width: "Ini",
    label_height: "Boý",
    label_frames: "Çarçuwalaryň sany",
    label_animation: "Animasiýa stili",
    label_background_color: "Fon reňki",
    label_interval: "Aralyk",
    tool_anim_config: "Animasiýa konfigurasiýasy",
    label_new_width: "Täze giňlik",
    label_new_height: "Täze beýiklik",
    label_apply: "Giriş",
    label_colors: "Reňkler",
    label_size: "Ölçegi",
    label_tolerance: "Çydamlylyk",
    val_horizontal: "Gorizontal",
    val_vertical: "Dik",
    val_sequence: "Yzygiderlilik",
    val_bounce: "Bounce",
    val_random: "Tötänleýin",
    val_solid: "Gaty",
    val_clear: "Arassala",
    action_add_sheet: "Täze sahypa",
    action_import: "Import",
    action_export: "Eksport",
    action_sort_projects: "Sort",
    sort_date_old: "Iň köne",
    sort_date_new: "Iň täze",
    sort_name_az: "Ady (A-Z)",
    sort_name_za: "Ady (Z-A)",
    action_new_sprite: "Täze Sprite",
    action_new_project: "Täze taslama",
    modal_save_all_title: "Changhli üýtgeşmeleri ýazdyryň",
    modal_save_all_desc: "Saklamak üçin emläkleri saýlaň:",
    modal_save_selected: "Saýlananlary ýazdyryň",
    action_saved: "Saklandy",
    modal_create_sprite_title: "Täze Sprite dörediň",
    modal_create_project_title: "Täze taslama dörediň",
    modal_add_sheet_title: "Täze sahypa goşuň",
    modal_rename_sheet_title: "Sahypanyň adyny üýtgediň",
    modal_rename_sprite_title: "Sprite adyny üýtgediň",
    modal_delete_sprite_title: "Sprite poz",
    modal_delete_project_title: "Taslamany poz",
    modal_delete_sheet_title: "Sahypany poz",
    placeholder_sprite_name: "Ady",
    placeholder_project_name: "Ady",
    placeholder_sheet_name: "Ady",
    placeholder_new_name: "Täze at",
    action_create: "Dörediň",
    action_add: "Goş",
    action_rename: "Adyny üýtgetmek",
    action_duplicate: "Dublikat",
    action_delete: "Öçür",
    action_cancel: "Elatyr",
    confirm_delete_sprite: "Bu spreiti ýok etmek isleýändigiňize ynanýarsyňyzmy?",
    confirm_delete_project: "Bu taslamany pozmak isleýändigiňize ynanýarsyňyzmy? Sphli spreýtler aýrylar.",
    confirm_delete_sheet: "Bu sahypany pozmak isleýändigiňize ynanýarsyňyzmy?",
    err_select_sprite: "Ilki bilen spreý saýlaň.",
    err_select_project: "Ilki bilen taslama saýlaň.",
    err_name_empty: "Ady boş bolup bilmez.",
    err_sprite_exists: "Şol atly spreýt eýýäm bar.",
    err_project_exists: "Şol at bilen bir taslama eýýäm bar.",
    err_no_content: "Saklamak üçin mazmun ýok.",
    err_no_changes: "Saklamak üçin üýtgeşme ýok.",
    err_delete_last_sheet: "Soňky sahypany pozup bolmaýar.",
    err_extract_frames: "Hiç hili ramka çykaryp bolmady.",
    err_indexeddb: "Locallyerli ýagdaýda saklap bilmedi. Brauzeriňiz IndexedDB-ni goldap bilmez.",
    msg_upload_success: "Üstünlikli ýüklemek: {0}",
    msg_upload_failed: "Uploadüklemek şowsuz: {0}",
    msg_save_success: "Üstünlikli tygşytlaň.",
    msg_saving: "Tygşytlamak ...",
    msg_multi_save_result: "{0} aktiwleri tygşytlandy. {1} şowsuzlyklar.",
    menu_title: "Menýu",
    menu_save: "Saklaň",
    menu_save_all: "Hemmesini sakla",
    menu_support: "Goldaw goldawy",
    label_local_storage: "Localerli ammar",
    label_sign_in: "Giriň",
    modal_export_title: "Sprite eksport ediň",
    label_filename: "Faýlyň ady",
    label_format: "Format",
    action_export_confirm: "Eksport",
};

export default translations;
